import type { UserLifecycle } from "./ticketLifecycleClassification";

/**
 * Maps chat ticket lifecycle (AI overview + heuristics) to Custom Workflow template types
 * (`User Onboarding` / `User Offboarding`) for API results from GET /custom-workflows.
 */
export const CUSTOM_WORKFLOW_TYPE_ONBOARDING = "User Onboarding";
export const CUSTOM_WORKFLOW_TYPE_OFFBOARDING = "User Offboarding";

export function lifecycleToCustomWorkflowType(
  lifecycle: Exclude<UserLifecycle, "none">
): typeof CUSTOM_WORKFLOW_TYPE_ONBOARDING | typeof CUSTOM_WORKFLOW_TYPE_OFFBOARDING {
  return lifecycle === "offboarding"
    ? CUSTOM_WORKFLOW_TYPE_OFFBOARDING
    : CUSTOM_WORKFLOW_TYPE_ONBOARDING;
}

/** True when the saved workflow row is a User Onboarding / User Offboarding workflow for this ticket lifecycle. */
export function customWorkflowMatchesTicketLifecycle(
  workflowType: string | null | undefined,
  lifecycle: Exclude<UserLifecycle, "none">
): boolean {
  const expected = lifecycleToCustomWorkflowType(lifecycle);
  return String(workflowType ?? "").trim() === expected;
}
